<div class="mobile-header">
  <span class="mobile-header__menu" (click)="toggleMobileMenu()">
    <i class="material-icons"> menu </i>
  </span>
  <h2 class="mobile-header__title">{{ title }}</h2>
  <ul class="mobile-header__links" *ngIf="links">
    <li *ngFor="let link of links" [routerLinkActive]="'active'">
      <a
        [routerLink]="link.path"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ link.title }}
      </a>
    </li>
  </ul>
</div>
